/* eslint-disable */
<template>
  <div class="updated-cases">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Recently Updated Cases</h1></div>
        <div class="header-sub-title">Click to view cases that have been recently updated.</div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu v-if="user.type >= 3" indexProps="9"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
              <el-select @change="selectPage(1)" style="max-width: 200px" placeholder="Claim Type"  class="mr-1" v-model="listParam.ClaimTypeID" filterable  clearable>
                <el-option v-for="item in types" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
              </el-select>
              <el-date-picker
                  v-model="dateValue"
                  type="daterange"
                  start-placeholder="Start Date"
                  popper-class="date-range-picker-popper"
                  value-format="yyyy-MM-dd"
                  format="dd/MM/yyyy"
                  @change="changeDates"
                  end-placeholder="End Date"
                  clearable
              />
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <el-table ref="bookingTable" :default-sort="{prop: 'Claimant', order: 'descending'}" stripe @sort-change="sortParam" :data="cases" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="100"
                  show-overflow-tooltip
                  label="CaseID"
                  prop="CaseID"
              >
                <template slot-scope="booking">
                  <router-link :to="{ name: 'admin-manage-case', query: { id: booking.row.CaseID } }">{{ booking.row.CaseID }}</router-link>
                </template>
              </el-table-column>
              <el-table-column
                  width="200"
                  sortable="custom"
                  show-overflow-tooltip
                  label="Client"
                  prop="Client"
              >
                <template slot-scope="booking">
                  <router-link :to="{ name: 'admin-manage-client', query: { id: booking.row.ClientID } }">{{ decodeURIComponent(booking.row.Client.ClientName) }}</router-link>
                </template>
              </el-table-column>
              <el-table-column
                  sortable="custom"
                  show-overflow-tooltip
                  label="Examinee"
                  prop="Claimant"
              >
                <template slot-scope="booking">
                  <span>{{decodeURIComponent(booking.row.ClaimantFirstName + ' ' + booking.row.ClaimantSurname)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="200"
                  show-overflow-tooltip
                  prop="LastUpdatedDate"
                  sortable="custom"
                  label="Date Modified"
              >
                <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.LastUpdatedDate, "DD/MM/YYYY")
                      }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="150"
                  show-overflow-tooltip
                  prop="LastUpdatedByUser"
                  sortable="custom"
                  label="Modified By"
              >
                <template slot-scope="scope">
                    <span>{{
                        decodeURIComponent(scope.row.LastUpdatedByUser.UserName)
                      }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AdminBookingsMenu from "@/components/AdminBookingsMenu"
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import Header from '@/components/Header'
  import { debounce } from 'lodash';
  export default {
    name: 'AdminUpdatedCases',
    props: ["searchOptionProps"],
    components: {
      AdminNavigation,
      Header,
      AdminBookingsMenu
    },
    data() {
      return {
        types: [],
        dateValue: "",
        cases: [],
        allCases: [],
        limit: 10,
        pagination: utilities.initPagination(),
        totalCount: 0,
        listParam: {
          pageSize: 10,
          pageNum: 1,
          orderBy: 'Claimant',
          ascOrDesc: 'DESC',
          ClaimTypeID: null,
          ClientName: '',
          ClaimantName: '',
          ContactName: '',
          LastUpdatedDateFrom: null,
          LastUpdatedDateTo: null,
        },
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
    },
    methods: {
      search: debounce(function () {
        this.selectPage(1)
      }, 800),

      sortParam( v ) {
        this.listParam.orderBy = v.prop
        if(v.order === "ascending") {
          this.listParam.ascOrDesc = 'ASC'
        } else if (v.order === "descending") {
          this.listParam.ascOrDesc = 'DESC'
        } else {
          this.listParam.orderBy = null
          this.listParam.ascOrDesc = null
        }

        this.selectPage(1)
      },
      changeDates(v) {
        if(v) {
          this.listParam.LastUpdatedDateFrom = v[0]
          this.listParam.LastUpdatedDateTo = v[1]
        } else {
          this.listParam.LastUpdatedDateFrom = null
          this.listParam.LastUpdatedDateTo = null
        }
        this.selectPage(1)
      },
      selectPage(index) {
        this.listParam.pageNum = index
        this.loadUpdatedCases()
      },
      formatDate(dateToFormat) {
        return utilities.formatDate(dateToFormat, 'DD/MM/YYYY')
      },

      async loadUpdatedCases() {
        await this.$store.dispatch('loading/setLoadComponent', true)
        const {data, total} = await utilities.getUpdatedCases(this.listParam)
        this.cases = _.cloneDeep(data)
        this.totalCount = total
        if(data.length == 0) {
          this.noCaseMessage = "No cases found."
        } else {
          this.noCaseMessage = ""
        }
        await this.$store.dispatch('loading/setLoadComponent', false)
      },
    },
    async beforeMount() {
      await this.loadUpdatedCases()
      this.types = await utilities.getClaimTypes()
    },
  }
</script>
